import React from "react";
import { Typography, CircularProgress } from "@mui/material";

function Loading() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <img
        src="/assets/loading-logo.jpeg"
        style={{
          borderRadius: "50%",
          padding: "10px",
        }}
        alt="logo"
        width="100"
      />
      <br />
      <CircularProgress />
      <Typography variant="body1" sx={{ ml: 2 }}>
        Loading...
      </Typography>
    </div>
  );
}

export default Loading;
